module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAARCAYAAAACCvahAAAAAXNSR0IArs4c6QAAAQNJREFUOE/dky1LRGEQhZ/HLhitJsGPtdtcxGL2F1gMVsFkF2w2sQqCgvjRdxX8AwprsCmKgqwYDGI4cuUil2W/sm8c5pn3zMwZ6fGSzAKLwL160S3NbsEky8AJcANMAgfqWmfuL5xkHKgWOgZawBYwDxwBU8BHpUDbJKvAfi/5feKnBTwCTHT8PEytlz+pSdaBM/WhH5lkE9hT21X4EdhQD5PUgGf1rZzJAtDUQmi+gSW10Qu+BM7VnSSj5aCm1bth4Ouyhe0kY8A7UFNv/zF8VfZcHdiM2hqm5zngqbKqOtAYalUDTNJ1z4WzCuO/DvBmoaKuNqsmWSkvZ5Cvv4Bd9fMHS0/czKdr9nsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/ic3.png
// module id = T5HP
// module chunks = 1